module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/common/surgicals/img06-a89bba6e9d2c83abdfcc8317715087b0.png";